import { API } from '@/api/Api'

import { GetBankingDashboardQuery } from '@/api/query/BankingDashboard.graphql'

export default {
  // Queries
  async GetBankingDashboard (accountId) {
    const Data = { accountId: accountId }

    return await API.GQLRequest(GetBankingDashboardQuery, Data)
  }
}
